export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultado"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transacción"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualizar estado"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enlaces útiles"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En progreso"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Éxito"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Falló"])}
}